interface ProgressBarProps {
  value: number; // 0-1 range
  color?: string;
}

export function ProgressBar({ value, color = 'bg-ink-2' }: ProgressBarProps) {
  const percentage = Math.min(100, Math.max(0, value * 100));

  return (
    <div className="h-1.5 bg-canvas-2 rounded-full overflow-hidden">
      <div
        className={`h-full transition-all duration-300 ${color}`}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
}